import React, { useContext,lazy, Suspense } from 'react';

import AppContext from './context/app/appContext';

import Layout from './layout/Layout';
import LeftMenu from './components/LeftMenu';
import Pagination from './components/Pagination';
import SelectedFilters from './components/SelectedFilters';
import List from './components/List';
import Loading from './Loading';

const MapView = lazy(() => import('./components/MapView'))

const renderLoader = () => <Loading />;


const Main = (props) => {

    const appContext = useContext(AppContext);

    return (
        <Layout>
            <div className="pagination">
                <SelectedFilters />
                <Pagination />
            </div>
            <LeftMenu />

            <div className="main">
                <List />
            </div>

            {appContext.showMap === true ? <Suspense fallback={renderLoader()}><MapView /></Suspense> : ''}

        </Layout>
    )
}
export default Main;
